import classNames from "classnames";
import { PageSectionProps } from "./PageSection.types";

export function PageSection({
  title,
  helperText,
  showDivider = false,
  children,
  className = "",
  actions,
}: PageSectionProps) {
  // A helper sentence stays close under its title; either way the body starts 1rem down.
  const headerMargin = helperText ? "mb-1" : "mb-3";
  const heading = title && (
    <h2
      className={classNames(
        "page-section__title fw-semibold h5",
        actions ? "mb-0" : headerMargin
      )}
    >
      {title}
    </h2>
  );

  return (
    <section className={classNames("page-section", className)}>
      {actions ? (
        <div
          className={classNames(
            "d-flex align-items-center justify-content-between gap-3",
            headerMargin
          )}
        >
          {heading}
          {actions}
        </div>
      ) : (
        heading
      )}
      {helperText && (
        <p className="page-section__helper fs-7 mb-3">
          {helperText}
        </p>
      )}
      {showDivider && <hr className="page-section__divider" />}
      <div className="page-section__body">{children}</div>
    </section>
  );
}
